import {
  Box,
  SimpleGrid,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  useColorModeValue,
} from "@chakra-ui/react";
import CalendarComponent from "components/calendar/CalendarScheduleOne";
import CalendarSupplierComponent from "components/calendar/CalendarScheduleSupplierOne";

// Custom components

// Assets
import LoadingComponent from "components/Main/Loading";
import { formatDateUs } from "helpers/formated";
import useScheduleSupplier from "hooks/Supplier/use-schedule-supplier";
import useSchedule from "hooks/use-schedule";
import { useEffect } from "react";

export default function ScheduleSupplierLeo() {
  const {
    getData,
    data,
    dateChaparia,
    dateFerragem,
    loadingChaparia,
    loadingCalendar,
    loadingFerragem,
    isFirstData,
  } = useScheduleSupplier();
  const bgLoading = useColorModeValue("white", "#111C44");

  useEffect(() => {
    const today = new Date();
    if (isFirstData) {
      if (data.length === 0) {
        getData(
          formatDateUs(new Date(today.getFullYear(), today.getMonth(), 1)),
          formatDateUs(new Date(today.getFullYear(), today.getMonth() + 1, 0))
        );
      }
    }
  });

  const getDataMinor = (start: any, end: any) => {
    getData(start, end);
  };
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Tabs variant="soft-rounded" colorScheme="green">
        <TabList pl={8}>
          {/* <Tab
            _selected={{
              bg: "#124907",
              color: "white",
            }}
          >
            Calendário
          </Tab> */}
        </TabList>
        <TabPanels>
          <TabPanel>
            <SimpleGrid
              mb="10px"
              columns={{ sm: 1, md: 1 }}
              spacing={{ base: "20px", xl: "20px" }}
            >
              <CalendarSupplierComponent
                data={data}
                sector="FERRAGEM"
                date={dateFerragem}
                getData={getDataMinor}
              />
            </SimpleGrid>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
}
